module.exports = __webpack_public_path__ + "img/3.010a0395.jpg";